// extracted by mini-css-extract-plugin
module.exports = {"delete":"PlanningModalCreneauDelete_delete__VyVL1"};